import React from 'react'
import styles from './styles.module.css'
import {
  DEFAULT_EYEBROW,
  DEFAULT_TITLE,
  DEFAULT_CAPTION,
  DEFAULT_VRS_LABEL,
  DEFAULT_OTHER_LABEL,
  DEFAULT_ROWS,
  CheckIcon,
  DashIcon,
} from './rows'

// GT-2 rig "vs the competition" comparison table. Pure display (no client state
// or router deps), so it renders identically on the dark hardware page and inside
// the product configurator. Data + icons live in ./rows.js so the copy is edited
// in ONE place for both surfaces. The `dark` prop flips it to the black-stage look
// used on the hardware page; the light default suits the white configurator page.
// Kept byte-identical to ./Server.jsx (the RSC twin) so the hardware page emits
// zero client JS for it.
function ComparisonTable({
  eyebrow = DEFAULT_EYEBROW,
  title = DEFAULT_TITLE,
  caption = DEFAULT_CAPTION,
  vrsLabel = DEFAULT_VRS_LABEL,
  otherLabel = DEFAULT_OTHER_LABEL,
  rows = DEFAULT_ROWS,
  dark,
  bg,
}) {
  const cls = [styles.wrap, dark && styles.dark].filter(Boolean).join(' ')
  return (
    <section className={cls} style={bg ? { background: bg } : undefined}>
      <div className={styles.inner}>
        {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
        {title && <h2 className={styles.title}>{title}</h2>}
        {caption && <p className={styles.caption}>{caption}</p>}
        {/* One grid for the whole table (rows are display: contents), so the
            VRS column can be painted as a single raised card behind its cells. */}
        <div
          className={styles.table}
          role="table"
          aria-label={`${vrsLabel} versus ${otherLabel}`}
          style={{ gridTemplateRows: `repeat(${rows.length + 1}, auto)` }}
        >
          <span className={styles.vrsColumn} aria-hidden="true" />
          <div className={[styles.row, styles.headRow].join(' ')} role="row">
            <span className={[styles.cell, styles.featureCell, styles.headCell].join(' ')} role="columnheader" />
            <span className={[styles.cell, styles.vrsCell, styles.headCell, styles.vrsHead].join(' ')} role="columnheader">
              <span className={styles.vrsBrand}>{vrsLabel}</span>
              <span className={styles.vrsTag}>All included</span>
            </span>
            <span className={[styles.cell, styles.otherCell, styles.headCell].join(' ')} role="columnheader">{otherLabel}</span>
          </div>
          {rows.map(({ Icon, feature, vrs, other }) => (
            <div className={styles.row} role="row" key={feature}>
              <span className={[styles.cell, styles.featureCell].join(' ')} role="rowheader">
                {Icon && <span className={styles.featureIcon}><Icon size={18} /></span>}
                <span className={styles.cellText}>{feature}</span>
              </span>
              <span className={[styles.cell, styles.vrsCell].join(' ')} role="cell">
                <span className={styles.check}><CheckIcon /></span>
                <span className={styles.cellText}>{vrs}</span>
              </span>
              <span className={[styles.cell, styles.otherCell].join(' ')} role="cell">
                <span className={styles.dash}><DashIcon /></span>
                <span className={styles.cellText}>{other}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ComparisonTable
